module.exports = __webpack_public_path__ + "img/ok-complete-green.92a97556.svg";